/* Timo's story copy, German. A retelling, not a translation.
 *
 * THIS IS THE FILE TO EDIT. Every line here is spoken out loud by Timo,
 * so write it the way it should sound, not the way it should look.
 *
 * How it plays: the story is five chapters. Each chapter is ONE text to
 * speech call, composed as
 *     [celebration or encouragement for the last word] + [chapter] + [invitation]
 * so the whole story costs five calls. That matters: the TTS layer allows
 * five calls per sixty seconds before it locks out, and caps a single call
 * at 2500 characters and silently truncates past it. Keep every chapter
 * between 500 and 700 characters and the composed line stays safe. German
 * runs longer than English, so cut a descriptive sentence rather than
 * building a longer one.
 *
 * Two refrains repeat word for word on purpose. A child joins in by the
 * third time they hear them, and joining in is the whole point:
 *     Timo hört zu. Timo wartet. Timo hilft.
 *     Sag es mit mir, sagte Timo.
 * Do not vary them for style. Sameness is the feature.
 *
 * The four target words are what the CHILD is asked to say. They are
 * picked to be the easiest words in their chapter, not the prettiest:
 * Baum, Nuss, Wasser, Mond. They are deliberately NOT translations of the
 * English targets home, nut, water, happy. Zuhause and glücklich are too
 * long and land on late developing sounds, so chapter 1 and chapter 4 were
 * rewritten around Baum and Mond instead. Do not swap one for a nicer word.
 */

const storyDe = {
  'story.title': 'Timos grüner Wald',
  // Timo hands the telling over to Hoppy, then the recorded story plays.
  'story.handoff': "Hey! Ich frage meinen Freund Hoppy, ob er sie erzählt.",

  // ==== Chapter 1: who Timo is (target: Baum, replaces English home) ====
  'story.ch1':
    'Timo wohnt in einem großen grünen Wald. Timo ist klein. Timo hat einen weichen Schwanz. ' +
    'Timo hat große runde Ohren. Große Ohren sind gut zum Zuhören. Im Wald wohnen viele Tiere. ' +
    'Da ist ein großer langsamer Bär. Da ist ein kleiner Vogel. Da sind zwei hungrige Eichhörnchen. ' +
    'Alle reden gleichzeitig. Es ist so laut. Aber Timo redet nicht zuerst. ' +
    'Timo hört zu. Timo wartet. Timo hilft. Timo wohnt in einem alten Baum. ' +
    'Der Baum ist sein Zuhause. Der Baum ist warm und weich. Von seinem Baum aus sieht Timo den ganzen Wald.',

  // ==== Chapter 2: the two squirrels (target: Nuss) ====
  'story.ch2':
    'Eines Tages fanden die zwei Eichhörnchen eine Nuss. Es war eine große braune Nuss. ' +
    'Beide wollten diese Nuss haben. Sie zogen die Nuss hierhin. Sie zogen die Nuss dorthin. ' +
    'Sie sagten kein einziges Wort. Sie zogen und zogen. Da kam Timo und setzte sich dazu. ' +
    'Timo hört zu. Timo wartet. Timo hilft. Dann sagte Timo, sag mir, was du möchtest. ' +
    'Sag es mit mir, sagte Timo. Das erste Eichhörnchen sagte, ich möchte die Nuss. ' +
    'Das zweite Eichhörnchen sagte, ich möchte die Nuss auch. Jetzt wissen wir es, sagte Timo. ' +
    'Ihr könnt die Nuss teilen. Also machten sie die Nuss in zwei Teile. Beide freuten sich.',

  // ==== Chapter 3: the little bird, the heart of it (target: Wasser) ====
  'story.ch3':
    'Dann kam der kleine Vogel. Er saß auf einem tiefen Ast. Ihm war warm und er hatte Durst. ' +
    'Der Vogel wollte etwas sagen. Aber das Wort kam nicht heraus. Er machte den Schnabel auf. ' +
    'Nichts kam. Er schaute auf seine Füße. Niemand drängte ihn. ' +
    'Timo hört zu. Timo wartet. Timo hilft. Timo saß ganz ruhig neben ihm. ' +
    'Dann sagte Timo das Wort zuerst, langsam und leise. Wasser. Sag es mit mir, sagte Timo. ' +
    'Der Vogel versuchte es. Wa. Er versuchte es noch einmal. Wasser. Er hat es gesagt! ' +
    'Er hat Wasser gesagt! Timo hüpfte auf und ab. Der ganze Wald jubelte für den kleinen Vogel.',

  // ==== Chapter 4: the forest changes, Timo hears the children (target: Mond, replaces English happy) ====
  'story.ch4':
    'Nach diesem Tag war der Wald anders. Der Bär wollte eine Beere. Also sagte er Beere. ' +
    'Die Eichhörnchen wollten spielen. Also sagten sie spielen. Der Vogel hatte Durst. ' +
    'Also sagte er Wasser. Niemand zog mehr. Niemand schubste mehr. Jetzt hatte jeder ein Wort. ' +
    'Am Abend saß Timo auf seinem warmen Stein. Er schaute hoch zum Mond. ' +
    'Der Mond war groß und rund und gelb. Der Mond leuchtete über dem ganzen Wald. ' +
    'Und da hörte Timo etwas Neues. Weit weg, hinter den Bäumen, waren Kinder. ' +
    'Sie hatten große Sachen zu erzählen. Aber die Wörter blieben drinnen stecken. Timo saß ganz still.',

  // ==== Chapter 5: Timo comes to the child ====
  'story.ch5':
    'Am Morgen packte Timo eine kleine Tasche. Er sagte tschüss zum großen langsamen Bären. ' +
    'Er sagte tschüss zu den zwei Eichhörnchen. Er sagte tschüss zum kleinen Vogel. ' +
    'Der Vogel sang ihm ein Lied. In dem Lied waren ganz viele Wörter. ' +
    'Dann ging Timo aus dem großen grünen Wald hinaus. Er ging einen langen, langen Weg. ' +
    'Seine großen Ohren waren die ganze Zeit offen. Timo hört zu. Timo wartet. Timo hilft. ' +
    'Und eines Tages, weit weg vom Wald, hörte er dich. Also bin ich jetzt hier. ' +
    'Ich bin nicht mehr im Wald. Ich bin genau hier bei dir. ' +
    'Und du hast große Sachen zu erzählen. Ich möchte sie so gern hören.',

  // ==== The four pauses: invitation, target word, celebration, encouragement ====
  'story.invite1': 'Der alte Baum ist Timos Zuhause, sag Baum mit mir.',
  'story.invite2': 'Eine große braune Nuss für zwei Freunde, sag Nuss mit mir.',
  'story.invite3': 'Der kleine Vogel hat sein Wort gefunden, sag Wasser mit mir.',
  'story.invite4': 'Der große runde Mond leuchtet über dem Wald, sag Mond mit mir.',

  'story.word1': 'Baum',
  'story.word2': 'Nuss',
  'story.word3': 'Wasser',
  'story.word4': 'Mond',

  'story.celebrate1': 'Baum! Du hast es gesagt, und meine großen Ohren wackeln vor Freude.',
  'story.celebrate2': 'Nuss! Das war schön. Die zwei Eichhörnchen winken dir zu.',
  'story.celebrate3': 'Wasser! Du hast es genau so gesagt wie der Vogel. Ich bin so stolz auf dich.',
  'story.celebrate4': 'Mond! Das war wunderschön, und der Mond hat dich gehört.',

  'story.encourage1': 'Baum, Baum, ein großer alter Baum. Komm mit, ich zeige dir meine Freunde.',
  'story.encourage2': 'Nuss, Nuss, eine große braune Nuss. Jetzt komm und lerne den kleinen Vogel kennen.',
  'story.encourage3': 'Wasser, Wasser, ein kühler Schluck Wasser. Komm und schau, was dann passierte.',
  'story.encourage4': 'Mond, Mond, ein großer runder Mond. Komm jetzt mit mir zum Ende.',

  'story.ending':
    'Komm morgen wieder, dann erzähle ich dir vom Bären und von der allerletzten Beere. Gute Nacht, mein Freund.',
};

export default storyDe;
